import PlayerHero from "./PlayerHero";

export default PlayerHero;
